// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ApolloClient = require("rescript-apollo-client/src/ApolloClient.bs.js");
var Client = require("@apollo/client");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var ApolloClient__Core_ApolloClient = require("rescript-apollo-client/src/@apollo/client/core/ApolloClient__Core_ApolloClient.bs.js");
var ApolloClient__Link_Http_HttpLink = require("rescript-apollo-client/src/@apollo/client/link/http/ApolloClient__Link_Http_HttpLink.bs.js");
var ApolloClient__Link_Retry_RetryLink = require("rescript-apollo-client/src/@apollo/client/link/retry/ApolloClient__Link_Retry_RetryLink.bs.js");
var ApolloClient__Cache_InMemory_InMemoryCache = require("rescript-apollo-client/src/@apollo/client/cache/inmemory/ApolloClient__Cache_InMemory_InMemoryCache.bs.js");

var graphqlEndpoint = "graphql.us.fauna.com/graphql";

var Cache = {};

function cache(initState, param) {
  var cache$1 = ApolloClient__Cache_InMemory_InMemoryCache.make(undefined, undefined, undefined, undefined, undefined, undefined);
  if (initState !== undefined) {
    return cache$1.restore(Caml_option.valFromOption(initState));
  } else {
    return cache$1;
  }
}

function makeHeaders(token) {
  return {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
          "X-Schema-Preview": "partial-update-mutation"
        };
}

function makeClient(initState, token, param) {
  var headers = makeHeaders(token);
  var httpLink = ApolloClient__Link_Http_HttpLink.make((function (param) {
          return "https://graphql.us.fauna.com/graphql";
        }), undefined, undefined, Caml_option.some(headers), undefined, undefined, undefined, undefined);
  var retryLink = ApolloClient__Link_Retry_RetryLink.make({
        TAG: /* RetryFunctionOptions */0,
        _0: {
          max: 3,
          retryIf: (function (maybeError, param) {
              var arg = Belt_Option.map(Belt_Option.map(Belt_Option.flatMap(Belt_Option.flatMap(Belt_Option.flatMap(maybeError, Js_json.decodeObject), (function (__x) {
                                  return Js_dict.get(__x, "statusCode");
                                })), Js_json.decodeNumber), (function (prim) {
                          return prim | 0;
                        })), (function (statusCode) {
                      return !(statusCode >= 400 && statusCode < 500 && statusCode !== 408 && statusCode !== 422 && statusCode !== 429);
                    }));
              return Promise.resolve((function (param) {
                              return OptionUtils$SmartcutsMacros.withDefault(param, arg);
                            })(false));
            })
        }
      }, {
        TAG: /* DelayFunctionOptions */0,
        _0: {
          initial: 300,
          max: Infinity | 0,
          jitter: 1
        }
      }, undefined);
  var ssrMode = typeof window === "undefined";
  return ApolloClient.make(undefined, undefined, undefined, Caml_option.some(Client.ApolloLink.from([
                      retryLink,
                      httpLink
                    ])), cache(initState, undefined), undefined, ssrMode, process.env.NODE_ENV === "development", undefined, ApolloClient__Core_ApolloClient.DefaultOptions.make(ApolloClient__Core_ApolloClient.DefaultMutateOptions.make(undefined, undefined, true, undefined, undefined, undefined), undefined, undefined, undefined), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

exports.graphqlEndpoint = graphqlEndpoint;
exports.Cache = Cache;
exports.makeHeaders = makeHeaders;
exports.makeClient = makeClient;
/* ApolloClient Not a pure module */
